if (!customElements.get('separate-variant-list')) {
  customElements.define(
    'separate-variant-list',
    class SeparateVariantList extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const addBtn = event.target.closest('[data-action="add-to-cart"]');
        if (!addBtn || !this.contains(addBtn)) return;

        event.preventDefault();
        this.addCardToCart(addBtn);
      }

      getInputMax(input) {
        if (!input.hasAttribute('max')) return Infinity;
        const max = parseInt(input.getAttribute('max'), 10);
        return Number.isNaN(max) ? Infinity : max;
      }

      getInputMin(input) {
        const min = parseInt(input.dataset.min, 10);
        return Number.isNaN(min) ? 1 : min;
      }

      addCardToCart(button) {
        const card = button.closest('.sv-card');
        if (!card || button.disabled || button.classList.contains('btn--loading')) return;

        if (typeof FoxTheme === 'undefined') {
          console.error('Separate variant list: FoxTheme is not available.');
          return;
        }

        const items = [];
        let hasStockError = false;

        card.querySelectorAll('.sv-card__row').forEach((row) => {
          const input = row.querySelector('.sv-card__qty-input');
          if (!input) return;

          const quantity = parseInt(input.value, 10) || 0;
          if (quantity <= 0) return;

          const max = this.getInputMax(input);
          if (quantity > max) {
            hasStockError = true;
            this.showCardError(
              card,
              window.separateVariantListStrings?.maxStockError || 'Max stock limit reached'
            );
            input.value = max === Infinity ? input.value : max;
            return;
          }

          items.push({
            id: parseInt(input.dataset.variantId, 10),
            quantity,
          });
        });

        if (hasStockError) return;

        if (items.length === 0) {
          const firstInput = card.querySelector('.sv-card__qty-input');
          if (firstInput) {
            const quantity = this.getInputMin(firstInput);
            const max = this.getInputMax(firstInput);

            if (quantity > max) {
              this.showCardError(
                card,
                window.separateVariantListStrings?.maxStockError || 'Max stock limit reached'
              );
              return;
            }

            firstInput.value = quantity;
            firstInput.dispatchEvent(new Event('change', { bubbles: true }));
            items.push({
              id: parseInt(firstInput.dataset.variantId, 10),
              quantity,
            });
          }
        }

        if (items.length === 0) return;

        this.clearCardError(card);
        this.toggleButtonLoading(button, true);

        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          items,
          sections: sectionsToBundle,
          sections_url: window.location.pathname,
        });

        fetch(`${FoxTheme.routes.cart_add_url}`, {
          ...FoxTheme.utils.fetchConfig('javascript'),
          body,
        })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.showCardError(
                card,
                parsedState.description ||
                  window.separateVariantListStrings?.addError ||
                  'Unable to add to cart'
              );
              return;
            }

            const cartJson = await (
              await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig('json', 'GET') })
            ).json();

            if (parsedState.items || parsedState.id) {
              cartJson.sections = parsedState.sections || {};
            }

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });

            document.dispatchEvent(
              new CustomEvent('product-ajax:added', {
                detail: { product: parsedState },
              })
            );

            card.querySelectorAll('.sv-card__qty-input').forEach((input) => {
              input.value = 0;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.show === 'function') {
              cartDrawer.show(button);
            }
          })
          .catch((error) => {
            console.error('Separate variant add to cart error:', error);
            this.showCardError(
              card,
              window.separateVariantListStrings?.addError || 'Unable to add to cart'
            );
          })
          .finally(() => {
            this.toggleButtonLoading(button, false);
          });
      }

      showCardError(card, message) {
        const errorEl = card?.querySelector('.sv-card__error');
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = false;
      }

      clearCardError(card) {
        const errorEl = card?.querySelector('.sv-card__error');
        if (!errorEl) return;
        errorEl.textContent = '';
        errorEl.hidden = true;
      }

      toggleButtonLoading(button, isLoading) {
        button.classList.toggle('btn--loading', isLoading);
        button.toggleAttribute('aria-disabled', isLoading);
      }
    }
  );
}
